import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Package, ShoppingCart, User } from 'lucide-react';

const navItems = [
  { key: 'products', label: 'Home', Icon: Home },
  { key: 'trackOrder', label: 'Track', Icon: Package },
  { key: 'cart', label: 'Cart', Icon: ShoppingCart },
  { key: 'profile', label: 'Profile', Icon: User },
];

export default function BottomNav({ navigate, currentPage, cartItemCount = 0 }) {
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 w-full z-50 pointer-events-auto bg-white shadow-md"
      aria-label="Primary mobile navigation"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="w-full flex items-center justify-around h-16 px-4">
        {navItems.map(({ key, label, Icon }) => {
          const active = currentPage === key || (key === 'products' && currentPage === 'products');
          const to = key === 'products' ? '/products' : `/${key}`;
          return (
            <NavLink
              key={key}
              to={to}
              onClick={() => navigate(key)}
              className={`flex-1 flex flex-col items-center justify-center py-2 no-underline transform transition-all duration-150 ease-out ${active ? 'scale-105' : 'scale-100'} relative`}
              aria-current={active ? 'page' : undefined}
              {...(key === 'cart' ? { 'data-cart-icon': true } : {})}
            >
              <Icon className={`w-6 h-6 transition-colors duration-150 ${active ? 'text-purple-600' : 'text-gray-400'}`} />
              {key === 'cart' && cartItemCount > 0 && (
                <span className="absolute top-0 right-1/4 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center animate-bounce">
                  {cartItemCount}
                </span>
              )}
              <span className={`mt-1 ${active ? 'text-sm font-semibold text-purple-600' : 'text-xs font-normal text-gray-500'} transition-colors duration-150`}>{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
